<div class="modal-header d-flex justify-content-center bg-light">
    <h4 class="modal-title text-center strong">Place bid<div>
            <div class="row">
                <div [ngClass]="InitialActive == true ? 'OrangeClass' : 'GreyClass'" class="col btn-next-month small">
                    Material #{{InitialValue}}</div>

                <div [ngClass]="FinalActive == true ? 'OrangeClass' : 'GreyClass'" class="col btn-next-month small">
                    Material #{{FinalValue}}</div>
            </div>
            <div class="avisible-lg position-relative">
                <div class="line1">
                    <img class="bg-secondary" src="/images/Div.svg" width="50%" alt="">
                    <div class="ellipse">
                        <img src="/images/Ellipse 18.svg" alt="" *ngIf="InitialActive">
                        <img src="/images/Ellipse 19_grey.svg" alt="" *ngIf="FinalActive">
                    </div>

                    <div class="ellipse-new position-absolute">
                        <img src="/images/Ellipse 18.svg" alt="" *ngIf="FinalActive">
                        <img src="/images/Ellipse 19_grey.svg" alt="" *ngIf="InitialActive">
                    </div>

                </div>
            </div>
        </div>
    </h4>
</div>
<div class="modal-body bg-light">
    <div class="center">
        <h5 class="lg-semibold-font mb-1">{{productInfo?.newName?productInfo?.newName:productInfo?.productName}}
        </h5>
        <div class="small text-secondary">{{'tenders.Deliveryperiod'| cxTranslate}}</div>
        <!-- <div class="strong small">{{productInfo && productInfo.loadPortLaycanStartDate | date:"dd/MM/yyyy"}} - {{productInfo && productInfo.loadPortLaycanEndDate | date:"dd/MM/yyyy"}}</div> -->
        <div class="strong small">{{productInfo?.laycanStartDate | date:"dd/MM/yyyy"}} -
            {{productInfo?.laycanEndDate | date:"dd/MM/yyyy"}}</div>
    </div>
    <div class="d-flex justify-content-between my-4">
        <div class="small">
            <h5 class="strong">{{ 'tenders.Quantity(DMT)' | cxTranslate
                }}({{productInfo.displayQuantityUnitDesc?productInfo.displayQuantityUnitDesc:''}})</h5>
            <h6 class="strong" *ngIf="productInfo.quantity && productInfo.isQuantityUnrestricted== false">
                {{productInfo.quantity | number}}</h6>
            <input type="number" min="0" max="999999" [(ngModel)]="productInfo.quantityshw" class="form-control"
                *ngIf="productInfo.quantity && productInfo.isQuantityUnrestricted== true">
        </div>
    </div>
    <div class="small" *ngIf=" productInfo.isDischargePortUnrestricted== true">
        <h5 class="strong">{{ 'tenders.DischargePort' | cxTranslate }}</h5>
        <input type="text" [(ngModel)]="productInfo.dischargePortshw" class="form-control form-control-lg">
    </div>

    <div class="mb-2">
        <div class="small">
            <div *ngIf="productInfo.baseKOP == 'BA CU'" class="small text-secondary">{{'tenders.QuotationPeriodCU'|
                cxTranslate}}</div>
            <div *ngIf="productInfo.baseKOP == 'BA ZN'" class="small text-secondary">{{'tenders.QuotationPeriodZN'|
                cxTranslate}}</div>
            <div *ngIf="productInfo.baseKOP != 'BA CU' && productInfo.baseKOP != 'BA ZN'" class="small text-secondary">
                {{'tenders.QuotationPeriod'| cxTranslate}} </div>
            <div *ngIf="productInfo.isQuotationPeriodUnrestricted == false && productInfo.pricingOptionsEnum[0].isQPMultipleChoicesSelected == false" class="small">{{formatQPDates(productInfo)}}
            </div>
            <select class="custom-select" (change)="qpChangeAction($event,productInfo)" *ngIf=" productInfo.pricingOptionsEnum[0].isQPMultipleChoicesSelected == true" [(ngModel)]="defaultValue">
                <option value="{{qp.description}}" id="{{qp.uniqueRowNumber}}" *ngFor="let qp of  productInfo.pricingOptionsEnum[0].qpMultipleChoices;" >{{qp.description}}  </option>    
            </select>
            <div *ngIf="productInfo.isQuotationPeriodUnrestricted == true &&  productInfo.pricingOptionsEnum[0].isQPMultipleChoicesSelected == true" class="small">{{getDate(productInfo?.finalQPFromDate)}} -
                {{getDate(productInfo?.finalQPToDate)}} (both dates inclusive)</div>
        </div>
    </div>
    <div class="mt-2">
        <div class="small text-secondary ">{{'tenders.TermsAndconditions'|cxTranslate}}</div>
        <div class=" small">{{code.termsAndConditions?code.termsAndConditions.description:'--'}} </div>
    </div>
    <div class="mt-3">
        <h6 class="strong">Enter your TC (per {{productInfo.displayTCPriceConfig.displayTCPriceUnitDesc}})</h6>
        <span class="currency-icon position-absolute">USD &nbsp;</span>
        <input [(ngModel)]="materialFixedPrice1" (change)="divide()" appAllowNegativeDecimalNumber
            [beforeDecimal]="productInfo.displayTCPriceConfig.displayTCPriceBeforeDecimals"
            [afterDecimal]="productInfo.displayTCPriceConfig.displayTCPriceAfterDecimals"
            class="form-control form-control-lg pl-5" preventCutCopyPaste required #name="ngModel" />
        <p *ngIf="PriceEmpty==true" class="text-danger my-1 md-semibold-font ">{{'home.productHeader.enterprice'|
            cxTranslate}}</p>
    </div>
    <div *ngIf="productInfo.displayRCPriceConfig.displayRCPrice == true">
        <h6 class="strong">Enter your RC (per {{productInfo.displayRCPriceConfig.displayRCPriceUnitDesc}} of payable
            Copper)</h6>
        <span class="currency-icon position-absolute">USD &nbsp;</span>
        <input [(ngModel)]="materialIndexPrice1" disabled class="form-control form-control-lg pl-5"
            preventCutCopyPaste required #name="ngModel" />
    </div>
    

</div>


<div class="modal-footer bg-light">
    <div class="w-100">
        <!-- <button class="btn btn-block btn-primary" type="submit" (click)="navigateToQuote(productInfo,quantitySelected)" data-dismiss="modal" [disabled]="startDate == null || disabledBtn || productInfo.priceValue =='' || productInfo.priceValue == 0 || productInfo.priceValue < productInfo.minPrice"> -->
        <button class="btn btn-block btn-primary btn-lg" (click)="Openmodal()">
            Next
        </button>
        <div class="d-flex justify-content-between mt-2">
            <button class="btn btn-lg btn-light button" type="button" (click)="backToPlacebid()">{{'tenders.Back'|
                cxTranslate}}</button>
            <button class="btn btn-lg btn-light button" type="button" (click)="ActiveModal.dismiss('close click')"
                data-dismiss="modal">{{ 'home.productHeader.Close' | cxTranslate }}</button>
        </div>
    </div>
</div>